/**
 * Giriş sonrası lisans/abonelik kapısı.
 *
 * Kimlik doğrulaması DAL'ın işi; burada yapılan, girişi TAMAMLAMADAN ÖNCE kullanıcıya
 * durumu söylemek: aboneliği bitmiş bir kurulumda ilk hatayı ekranın ortasında
 * görmesindense, nedenini girişte öğrenmeli. Kapı engellemez — sunucu kabul ettiyse
 * kullanıcı "Devam et" diyerek girer; amaç bilgilendirmek ve yöneticiye gitmesini
 * sağlamak.
 *
 * Node kullanıcısı da burada uyarılır: web lisansı olmayan kullanıcı el terminali
 * görünümüne düşüyor ve bugüne kadar bu sessizce oluyordu.
 */
export type LicenseNoticeKind = 'expired' | 'expiring' | 'nodeOnly' | null;

export interface LicenseNotice {
  kind: Exclude<LicenseNoticeKind, null>;
  /** 'expiring' için kalan gün, 'expired' için 0 */
  days: number;
  /** Bitiş tarihi (yerel biçimlendirme çağıranda) */
  date: Date | null;
}

export interface LicenseGateInput {
  hasWebLicense: boolean;
  hasNodeLicense: boolean;
  /** Support'tan gelen abonelik bitişi; kurulumda tanımsız olabilir. */
  expirationDate?: string | null;
  /** Uyarının başladığı eşik (gün) */
  warnWithinDays?: number;
  now?: Date;
}

/** Gün farkı — saat/dakika değil TARİH farkı; bugün biten abonelik "0 gün" görünmeli. */
function daysBetween(from: Date, to: Date): number {
  const a = Date.UTC(from.getFullYear(), from.getMonth(), from.getDate());
  const b = Date.UTC(to.getFullYear(), to.getMonth(), to.getDate());
  return Math.round((b - a) / 86_400_000);
}

export function licenseNotice(input: LicenseGateInput): LicenseNotice | null {
  const now = input.now ?? new Date();
  const warnWithin = input.warnWithinDays ?? 10;

  const parsed = input.expirationDate ? new Date(input.expirationDate) : null;
  const expires = parsed && !Number.isNaN(parsed.getTime()) ? parsed : null;

  if (expires) {
    const days = daysBetween(now, expires);
    if (days < 0) return { kind: 'expired', days: 0, date: expires };
    if (days <= warnWithin) return { kind: 'expiring', days, date: expires };
  }

  // Abonelik sağlamsa sıra kullanıcının lisansında: web yoksa node görünümüne düşecek.
  if (!input.hasWebLicense && input.hasNodeLicense) return { kind: 'nodeOnly', days: 0, date: expires };

  return null;
}
